import gql from "graphql-tag";

export const PUBLISH_PAGE_LAYOUT_MUTATION = gql`
  mutation PublishPageLayout($input: PublishPageLayoutInput!) {
    publishPageLayout(input: $input) {
      statusCode
      message
      status
    }
  }
`;
